// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modalFullscreen__content-3851H";
var _4 = "modalFullscreen__fixed-251Xx";
var _5 = "modalFullscreen__root-2EWYU";
var _6 = "modalFullscreen__header-2K3zN";
export { _1 as "__esModule", _2 as "mobile", _3 as "modalFullscreen__content", _4 as "modalFullscreen__fixed", _5 as "modalFullscreen__root", _6 as "modalFullscreen__header" }
export default { "__esModule": _1, "mobile": _2, "modalFullscreen__content": _3, "modalFullscreen__fixed": _4, "modalFullscreen__root": _5, "modalFullscreen__header": _6 }
